<script setup>

import {computed, onMounted, reactive, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import LoadingIcon from "@/components/LoadingIcon.vue";
import Paginate from "vuejs-paginate-next"
import {accessControlApi, css_selectors_Api} from "@/api/forwriting_index";
import {datePipe} from "@/utils/datatimeUtils";
import CheckPointLimit from "@/views/forwriting/fw00_check_point_limit.vue"

const route = useRoute()
const router = useRouter();
const article_list = reactive({
  id: parseInt(route.params.article_list_id) || null
})

// ==== modal_new ====

const modal_new = reactive({
  show: false,
  css_selector: {
    "article_list_id": article_list.id,
    "domain_pattern": "",
    "path_pattern": ".*",
    "selectors": "[]",  // JSON array string
    "priority": 100,
    "is_active": true,
  },
  open() {
    // 確保 article_list_id 是最新的
    article_list.id = parseInt(route.params.article_list_id) || null
    this.css_selector.article_list_id = article_list.id
    this.css_selector.domain_pattern = ""
    this.css_selector.path_pattern = ".*"
    this.css_selector.selectors = "[]"
    this.css_selector.priority = 100
    this.css_selector.is_active = true
    this.show = true
  }
})
const modal_new_create = async () => {
  isLoading.show = true;
  
  // 確保 article_list_id 存在
  article_list.id = parseInt(route.params.article_list_id) || null
  if (!article_list.id) {
    alert("article_list_id 不存在，請重新載入頁面");
    isLoading.show = false;
    return;
  }
  
  // 更新 modal_new.css_selector 中的 article_list_id
  modal_new.css_selector.article_list_id = article_list.id
  
  // 驗證 selectors 是有效的 JSON array
  try {
    const selectorsArray = JSON.parse(modal_new.css_selector.selectors);
    if (!Array.isArray(selectorsArray)) {
      alert("Selectors 必須是 JSON 陣列格式");
      isLoading.show = false;
      return;
    }
  } catch (e) {
    alert("Selectors 必須是有效的 JSON 格式");
    isLoading.show = false;
    return;
  }
  
  const resp = await css_selectors_Api.new( article_list.id, modal_new.css_selector)
  if( resp.status !== 200) {
    isLoading.show = false;
    throw new Error("ERROR");
  }
  await reload_data()
  isLoading.show = false;

  modal_new.show = false;
}

// ==== modal_update ====

const modal_update = reactive({
  show: false,
  css_selector: {
    "article_list_id": article_list.id,
    "domain_pattern": "",
    "path_pattern": ".*",
    "selectors": "[]",
    "priority": 100,
    "is_active": true,
  },
  id: -1
})
const handleEdit = async ( par_id) => {
  console.log( "handleEdit() -> par_id:", par_id)
  modal_update.id = par_id

  // 確保 article_list_id 是最新的
  article_list.id = parseInt(route.params.article_list_id) || null
  modal_update.css_selector.article_list_id = article_list.id

  const resp = await css_selectors_Api.get_1( par_id)
  modal_update.css_selector.domain_pattern = resp.data.domain_pattern || ""
  modal_update.css_selector.path_pattern = resp.data.path_pattern || ".*"
  modal_update.css_selector.selectors = resp.data.selectors || "[]"
  modal_update.css_selector.priority = resp.data.priority || 100
  modal_update.css_selector.is_active = resp.data.is_active !== undefined ? resp.data.is_active : true

  modal_update.show = true
}
const handleEdit_confirm = async ( ) => {
  isLoading.show = true;

  // 確保 article_list_id 存在
  article_list.id = parseInt(route.params.article_list_id) || null
  if (!article_list.id) {
    alert("article_list_id 不存在，請重新載入頁面");
    isLoading.show = false;
    return;
  }
  
  // 更新 modal_update.css_selector 中的 article_list_id
  modal_update.css_selector.article_list_id = article_list.id

  // 驗證 selectors 是有效的 JSON array
  try {
    const selectorsArray = JSON.parse(modal_update.css_selector.selectors);
    if (!Array.isArray(selectorsArray)) {
      alert("Selectors 必須是 JSON 陣列格式");
      isLoading.show = false;
      return;
    }
  } catch (e) {
    alert("Selectors 必須是有效的 JSON 格式");
    isLoading.show = false;
    return;
  }
  
  const resp = await css_selectors_Api.update( article_list.id, modal_update.id, modal_update.css_selector)
  if( resp.status !== 200) {
    isLoading.show = false;
    throw new Error("ERROR");
  }

  await reload_data()
  isLoading.show = false;

  modal_update.show = false
}

// ==== modal_del_1 ====

const modal_del_1 = reactive({
  show: false,
  msg: "",
  id: -1,
})
const handleDelete = async ( par_id, domain_pattern) => {
  modal_del_1.msg = `確定要刪除 CSS Selector (${domain_pattern}) 嗎？`
  modal_del_1.id = par_id
  modal_del_1.show = true;
};
const handleDelete_confirm = async () => {
  isLoading.show = true;

  const resp = await css_selectors_Api.delete( article_list.id, modal_del_1.id );
  if( resp.status !== 200) {
    isLoading.show = false;
    throw new Error("ERROR");
  }

  data.items = data.items.filter( ( item) => item.id !== modal_del_1.id);

  isLoading.show = false;
  modal_del_1.show = false;
};

// ==== modal_del_selected ====

const modal_del_selected = reactive({
  show: false,
  msg: "",
  ids: [],
})
const del_selected = async () => {
  modal_del_selected.ids = []
  for (const i in checked.items)
    if( checked.items[i])
      modal_del_selected.ids.push( i)

  modal_del_selected.msg = `確定要刪除 ${modal_del_selected.ids.length} 個 CSS Selector 嗎？`
  modal_del_selected.show = true
}
const del_selected_confirm = async () => {
  isLoading.show = true
  for( const i in modal_del_selected.ids)
  {
    const id = modal_del_selected.ids[i]
    const resp = await css_selectors_Api.delete( article_list.id, id );
    if( resp.status !== 200) {
      isLoading.show = false;
      throw new Error("ERROR");
    }
  }
  await reload_data()
  isLoading.show = false

  modal_del_selected.show = false
}

// ==== filter ====

const filter = reactive({
  temp: "",
  searchKey: null,
});
const handleFilter = () => {
  filter.searchKey = filter.temp
  page.current = 1
};
const filteredData = computed(() => {
  let temp = data.items || [];
  if( filter.searchKey)
  {
    const str_filter = filter.searchKey.toLowerCase()
    temp = temp.filter( ( item) =>
        String( item.domain_pattern || "").toLowerCase().indexOf( str_filter) > -1 ||
        String( item.path_pattern || "").toLowerCase().indexOf( str_filter) > -1 ||
        String( item.selectors || "").toLowerCase().indexOf( str_filter) > -1
    )
  }
  return temp;
});

// ==== paging ====

const page = reactive({
  current: 1,
  num: 10,
})
const page_count = computed(() => {
  let cc = Math.floor( filteredData.value.length / page.num)
  if( filteredData.value.length % page.num === 0)
    return cc
  return cc + 1
})

// ==== init data... ====

const data = reactive({
  items: [],
})
const reload_data = async( ) => {
  if (!article_list.id) {
    console.error("article_list_id is missing:", route.params)
    return
  }
  const resp = await css_selectors_Api.getAll_filter( article_list.id)
  data.items = resp.data;

  for( let i in data.items) {
    const id = data.items[i].id
    checked.items[ id] = false
  }
}
onMounted(async () => {
  if( ! await accessControlApi.check_option_access()) {
    await router.push(`/forwriting/options_error`)
    return
  }

  // 確保 article_list_id 存在（在 onMounted 時重新獲取，確保路由參數已準備好）
  article_list.id = parseInt(route.params.article_list_id) || null
  if (!article_list.id) {
    console.error("article_list_id is missing from route params:", route.params)
    return
  }

  await reload_data()

  // check the point_limit
  point_limit.is_over = await ref_CheckPointLimit.value.check();
});

// ==== checked/un-checked ====

const checked = reactive({
  items: {}
})
const onSelectAllChange = async( e) => {
  const checked_val = e.target.checked
  for( const i in checked.items)
    checked.items[i] = checked_val
}

// ==== button refresh ====

const refreshPage = async () => {
  await reload_data()
}

// ==== isLoading ====

const isLoading = reactive({
  show: false
})

// ==== modal_over_points ====
const ref_CheckPointLimit = ref(null)
const point_limit = reactive({
  is_over: false,
})

// ==== helper function to format selectors ====
const formatSelectors = (selectorsStr) => {
  try {
    const selectors = JSON.parse(selectorsStr || "[]");
    if (Array.isArray(selectors) && selectors.length > 0) {
      return selectors.join(", ");
    }
    return selectorsStr || "";
  } catch (e) {
    return selectorsStr || "";
  }
}

</script>

<template>

  <!-- isLoading -->
  <LoadingIcon :is-loading="isLoading.show"></LoadingIcon>

  <!-- modal_over_points -->
  <CheckPointLimit ref="ref_CheckPointLimit"></CheckPointLimit>

  <!-- Modal_new" -->
  <div v-if="modal_new.show" class="modal-create">
    <div class="modal-content">

      <div class="row" >
        <h4>{{ $t( "Articles.css_selector_new") }}</h4>
      </div>

      <div class="row" style="margin-top: 30px">
        <label>{{ $t( "Articles.domain_pattern") }}:</label>
        <input type="text" style="margin-left: 10px; width: 800px"
               v-model="modal_new.css_selector.domain_pattern" :placeholder="$t( 'Articles.domain_pattern_placeholder')"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.path_pattern") }}:</label>
        <input type="text" style="margin-left: 10px; width: 800px"
               v-model="modal_new.css_selector.path_pattern" :placeholder="$t( 'Articles.path_pattern_placeholder')"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.selectors_json_array") }}:</label>
        <textarea style="margin-left: 10px; width: 800px; height: 100px"
                  v-model="modal_new.css_selector.selectors" :placeholder="$t( 'Articles.selectors_placeholder')"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.priority") }}:</label>
        <input type="number" style="margin-left: 10px; width: 200px"
               v-model.number="modal_new.css_selector.priority"/>
        <span style="margin-left: 10px; color: #666;">{{ $t( "Articles.priority_hint") }}</span>
      </div>

      <div class="row" style="margin-top: 20px;">
        <label style="display: inline-flex; align-items: center; gap: 2px; margin: 0; white-space: nowrap;">
          {{ $t( "Articles.enable") }}:<input type="checkbox" style="margin: 0 0 0 2px;" v-model="modal_new.css_selector.is_active"/>
        </label>
      </div>

      <!-- 2 buttons-->
      <div class="row" style="margin-top: 200px">
        <button class="btn btn-primary"
                style="width: 120px; margin-left: 20px"
                @click="modal_new_create">
          {{ $t( "Articles.append_2") }}</button>

        <button class="btn btn-primary" style="width: 120px; margin-left: 20px"
                @click="modal_new.show=false">
          {{ $t( "Articles.cancel") }}</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_new" -->

  <!-- Modal_update" -->
  <div v-if="modal_update.show" class="modal-create">
    <div class="modal-content">

      <div class="row" >
        <h4>{{ $t( "Articles.css_selector_edit") }}</h4>
      </div>

      <div class="row" style="margin-top: 30px">
        <label>{{ $t( "Articles.domain_pattern") }}:</label>
        <input type="text" style="margin-left: 10px; width: 800px"
               v-model="modal_update.css_selector.domain_pattern"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.path_pattern") }}:</label>
        <input type="text" style="margin-left: 10px; width: 800px"
               v-model="modal_update.css_selector.path_pattern"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.selectors_json_array") }}:</label>
        <textarea style="margin-left: 10px; width: 800px; height: 100px"
                  v-model="modal_update.css_selector.selectors"/>
      </div>

      <div class="row" style="margin-top: 20px">
        <label>{{ $t( "Articles.priority") }}:</label>
        <input type="number" style="margin-left: 10px; width: 200px"
               v-model.number="modal_update.css_selector.priority"/>
        <span style="margin-left: 10px; color: #666;">{{ $t( "Articles.priority_hint") }}</span>
      </div>

      <div class="row" style="margin-top: 20px;">
        <label style="display: inline-flex; align-items: center; gap: 2px; margin: 0; white-space: nowrap;">
          {{ $t( "Articles.enable") }}:<input type="checkbox" style="margin: 0 0 0 2px;" v-model="modal_update.css_selector.is_active"/>
        </label>
      </div>

      <!-- 2 buttons-->
      <div class="row" style="margin-top: 200px">
        <button class="btn btn-primary"
                style="width: 120px; margin-left: 20px"
                @click="handleEdit_confirm">
          {{ $t( "Articles.update") }}</button>

        <button class="btn btn-primary" style="width: 120px; margin-left: 20px"
                @click="modal_update.show=false">
          {{ $t( "Articles.cancel") }}</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_update" -->

  <!-- modal_del_selected -->
  <div v-if="modal_del_selected.show" class="modal-del">
    <div class="modal-content">

      <div class="row" style="margin-top: 20px;text-align: center">
        <p>{{ modal_del_selected.msg }}</p>
      </div>

      <!-- 2 buttons -->

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="del_selected_confirm">
          確定</button>
      </div>

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="modal_del_selected.show = false">
          取消</button>
      </div>

    </div>
  </div>
  <!-- end of modal_del_selected -->

  <!-- modal_del_1 -->
  <div v-if="modal_del_1.show" class="modal-del">
    <div class="modal-content">

      <div class="row" style="margin-top: 20px;text-align: center">
        <p>{{ modal_del_1.msg }}</p>
      </div>

      <!-- 2 buttons -->
      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="handleDelete_confirm">
          確定</button>
      </div>

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="modal_del_1.show = false">
          取消</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_delete -->

  <div class="container">

    <!-- title-->
    <div class="row">
      <h4>{{ $t( "Articles.css_selector") }}</h4>
    </div>

    <!-- key for filer(關鍵詞過濾) -->
    <div class="row">
      <div class="column">

        <label for="search-keyword">キーワード:</label>
        <input type="text" id="search-keyword" v-model="filter.temp"
               style="padding: 0 10px; margin: 10px;"/>

        <button class="btn btn-primary" @click="handleFilter"
                style="padding: 0 50px; margin: 10px;">
          絞り込み</button>
      </div>

    </div>

    <!-- 3 button -->
    <div class="row">
      <div class="column" style="text-align: right">

        <button class="btn btn-primary"
                @click="modal_new.open"
                style="padding: 0 50px; margin: 10px;">
          + 新規追加</button>

        <button class="btn btn-primary"
                @click="del_selected"
                style="padding: 0 50px; margin: 10px;">
          一括削除</button>

        <button class="btn btn-primary" @click="refreshPage"
                style="padding: 0 50px; margin: 10px;">
          一覧更新
        </button>

      </div>
    </div>

    <!-- select/de-select -->
    <div class="row">
      <div class="column">
        <input id="select_all" type="checkbox" @change="onSelectAllChange"/>
        <label style="padding: 0 10px; margin: 1px;" for="select_all">
          全選択/解除</label>
      </div>
    </div>

    <div class="row">

      <!-- the main table(主體表格) -->
      <table class="table table-hover">

        <thead>
        <tr>
          <th scope="col">対象</th>
          <th scope="col">{{ $t( "Articles.css_selector_name") }}</th>
          <th scope="col">作成日時</th>
          <th scope="col">操作</th>
        </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in filteredData" :key="item.id"
              v-show="( Math.floor( index / page.num) + 1) === page.current"
              style="vertical-align: center">

            <td><input type="checkbox" v-model="checked.items[ item.id]"></td>

            <td>
              <div>
                <strong>{{ item.domain_pattern || 'default' }}</strong>
                <span v-if="item.is_system_default" class="badge bg-info" style="margin-left: 10px;">デフォルト</span>
              </div>
              <div style="font-size: 0.9em; color: #666; margin-top: 5px;">
                Path: {{ item.path_pattern || '.*' }} | Selector: {{ formatSelectors(item.selectors) }}
              </div>
            </td>
            <td>{{ datePipe(item.created_at, format = 'yyyy/MM/dd')}}</td>

            <td>
              <button v-if="!item.is_system_default" 
                      class="btn btn-primary" style="padding: 0 20px"
                      @click="handleEdit( item.id)">
                編集</button>

              <button v-if="!item.is_system_default" 
                      class="btn btn-danger" style="padding: 0 20px; margin-top: 1px;margin-left: 10px"
                      @click="handleDelete( item.id, item.domain_pattern)">
                削除</button>
            </td>

          </tr>
        </tbody>
      </table>

    </div>
    <div class="row">
      <paginate style="margin-left: 300px; cursor: pointer;"
                v-model="page.current"

                :page-count="page_count"
                :page-range="3"
                :margin-pages="2"

                :prev-text="'<'"
                :next-text="'>'"
      >
      </paginate>
    </div>
  </div>

</template>

<style scoped>
.tr-line {
  height: 50px;
}

.td-left {
  text-align: right;
  width: 150px;
}

.td-right {
  text-align: left;
  width: 720px;
}

.td-combo {
  margin-top: 10px;
  margin-left: 10px;
  width: 320px;
}

.td-text {
  padding: 0 10px;
  margin: 10px;
  width: 720px;
}

.modal-del {
  height: 800px;
  max-height: 1024px;
  width: 480px;

  display: flex;
  justify-content: center;
  align-items: center;

  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;

  top: 100px;
  left: 100px;
  position: absolute;
  padding: 20px;
}

.modal-create {
  height: 960px;
  max-height: 1280px;
  width: 960px;

  display: flex;
  justify-content: center;
  align-items: center;

  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;

  top: 100px;
  left: 100px;
  position: absolute;
  padding: 20px;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  max-width: 1600px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.badge {
  display: inline-block;
  padding: 0.25em 0.6em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.bg-info {
  background-color: #0dcaf0;
  color: #000;
}

</style>

